import connectionsStore, { ConsumerKind3, PlaceID3 } from "@mobx/store/connections";
import { useMemo } from "react";
import usePlaceID3 from "./usePlaceID";

export const useIsSelectedForDrag3 = (id: string, kind: ConsumerKind3, extPlaceID?: PlaceID3) => {
  const { placeID: intPlaceID } = usePlaceID3(true);
  const placeID = extPlaceID ?? intPlaceID;
  const dragStore = useMemo(() => placeID ? (connectionsStore.getPlaceStore(placeID)?.drag) : undefined, [placeID]);
  const dragElements = dragStore
    ? dragStore.drags.filter(el => el.id === id && el.kind === kind)
    : [];

  return !!dragElements?.length;
}

export const useHasSelectedForDrag3 = (kind: ConsumerKind3, extPlaceID?: PlaceID3) => {
  const { placeID: intPlaceID } = usePlaceID3(true);
  const placeID = extPlaceID ?? intPlaceID;
  const dragStore = useMemo(() => placeID ? (connectionsStore.getPlaceStore(placeID)?.drag) : undefined, [placeID]);
  const dragElements = dragStore
    ? dragStore.drags.filter(el => el.kind === kind)
    : [];

  return !!dragElements?.length;
}
